import { Component } from '@angular/core';
import { CreateBankAccount } from '../../../../../app/components/admin-dashboard-component/bank-account/create-bank-account/create-bank-account';

@Component({
  selector: 'app-bank-account-create',
  imports: [CreateBankAccount],
  templateUrl: './bank-account-create.html',
  styleUrl: './bank-account-create.scss',
})
export class BankAccountCreate {}
